module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('z-basePage', {
    attrs: {
      "title": '角色设置'
    }
  }, [_c('div', {
    staticClass: "role-main"
  }, [_c('div', {
    staticClass: "tip"
  }, [_c('span', [_vm._v("为前台权限")]), _vm._v(" "), _c('span', [_vm._v("为后台权限")])]), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "add"
  }, [_c('el-input', {
    ref: "input",
    attrs: {
      "placeholder": "请输入角色名称"
    },
    model: {
      value: (_vm.inputText),
      callback: function($$v) {
        _vm.inputText = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "inputText"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "back-btn",
    on: {
      "click": _vm.addItem
    }
  }, [_vm._v("添加")])], 1), _vm._v(" "), _c('z-scrollDiv', {
    staticClass: "list"
  }, _vm._l((_vm.role_list_calc), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "name-item",
      class: {
        active: _vm.now_roleId === item.id
      },
      on: {
        "click": function($event) {
          _vm.getRoleData(item.id)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(item.displayName) + "\n                    "), (_vm.nameJudge(item.name)) ? _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.now_roleId === item.id),
        expression: "now_roleId === item.id"
      }],
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.deleteItem($event)
        }
      }
    }, [_vm._v("删除")]) : _vm._e()])
  }))], 1), _vm._v(" "), _c('z-scrollDiv', {
    staticClass: "right"
  }, [_vm._l((_vm.bigData), function(data, index) {
    return _c('div', {
      staticClass: "role-item"
    }, [_c('div', {
      staticClass: "title",
      class: {
        front: _vm.codeJudge(data)
      }
    }, [_c('span', [_vm._v(_vm._s(data.title))]), _vm._v(" "), _c('el-checkbox', {
      attrs: {
        "disabled": _vm.admin_item.id == _vm.now_roleId,
        "indeterminate": _vm.optionLen[index] < data.options.length && _vm.optionLen[index] > 0
      },
      on: {
        "change": function($event) {
          _vm.checkAll(data, $event)
        }
      },
      model: {
        value: (data.check_all),
        callback: function($$v) {
          _vm.$set(data, "check_all", $$v)
        },
        expression: "data.check_all"
      }
    })], 1), _vm._v(" "), _c('el-checkbox-group', {
      staticClass: "group",
      on: {
        "change": function($event) {
          _vm.chooseChange(data, index)
        }
      },
      model: {
        value: (_vm.sub_ids),
        callback: function($$v) {
          _vm.sub_ids = $$v
        },
        expression: "sub_ids"
      }
    }, _vm._l((data.options), function(item) {
      return _c('el-checkbox', {
        key: item.id,
        attrs: {
          "disabled": _vm.admin_item.id == _vm.now_roleId,
          "label": item.id
        }
      }, [_vm._v(_vm._s(item.text))])
    }))], 1)
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.admin_item.id != _vm.now_roleId),
      expression: "admin_item.id != now_roleId"
    }],
    staticClass: "btn-bottom"
  }, [_c('div', {
    staticClass: "back-btn blue",
    class: {
      disabled: !_vm.now_form.changeFlag
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('div', {
    staticClass: "back-btn",
    class: {
      disabled: !_vm.now_form.changeFlag
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])])], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "form",
      rawName: "v-form",
      value: ('back-role'),
      expression: "'back-role'"
    }, {
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('input', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.sub_ids_str),
      expression: "sub_ids_str"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.sub_ids_str),
      expression: "sub_ids_str"
    }],
    domProps: {
      "value": (_vm.sub_ids_str)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sub_ids_str = $event.target.value
      }
    }
  })])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-98de666c!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/backEndStage/person/page-role.vue
// module id = 775
// module chunks = 1